import * as angular from 'angular';
import { FolhasdePontoService } from './folhasdeponto.service';

export const FolhasdePontoListRouting = [
	'$stateProvider',
	function ($stateProvider: angular.ui.IStateProvider): void {
		let resolve = {
			'entity': [
				'FolhasdePontoService',
				'$stateParams',
				'$state',
				'$q',
				function (
					entityService: FolhasdePontoService,
					$stateParams: angular.ui.IStateParamsService,
					$state: angular.ui.IStateService,
					$q: angular.IQService
				): angular.ui.IStateParamsService | angular.IQService | {} {
					if ($stateParams['entity']) {
						return $stateParams['entity'];
					}

					if (!$stateParams['solicitacao']) {
						return {};
					}

					return $q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
						entityService.get($stateParams['solicitacao'])
							.then((data: unknown): void => {
								resolve(data);
							})
							.catch((error: any): void => {
								if (error.status === 404) {
									if ($state.href('ferias_marcacoes_not_found', $stateParams)) {
										$state.go('ferias_marcacoes_not_found', $stateParams);
									} else {
										$state.go('not_found', $stateParams);
									}
								}
							});
					});
				}
			]
		};

		$stateProvider
			.state('folhasdeponto', {
				url: '/ponto/folhas?q?situacao?estabelecimento?apuracaoponto',
				template: require('html-loader!./index/folhasdeponto.index.html'),
				controller: 'FolhasPontoIndexController',
				controllerAs: 'mrh_flhspt_lst_cntrllr',
				reloadOnSearch: false
			});
	}
];
